module.exports = __webpack_public_path__ + "img/login_back.png";